import Typography from "../../Utility/Typography";

/**
 * Workflow category counts (New, In Progress, Done, …) with flex-wrap so long summaries do not break awkwardly.
 * @param {{ label: string, count: number }[]} parts
 * @param {number|null} [total]
 */
export default function DashboardCategorySummary({ parts = [], total = null }) {
  if (!parts.length) return null;
  const totalCount = total;

  return (
    <div
      className="mb-3 flex flex-wrap items-baseline gap-x-1 gap-y-1.5 text-sm text-gray-600"
      role="list"
      aria-label="Work item counts by status"
    >
      {parts.map((part, index) => (
        <Typography
          key={`${part.label}-${index}`}
          variant="span2"
          component="span"
          className="inline-flex items-baseline whitespace-nowrap"
          role="listitem"
        >
          {index > 0 ? (
            <span className="mx-0.5 text-gray-400" aria-hidden>
              ·
            </span>
          ) : null}
          <span className="font-medium text-gray-700">{part.label}:</span>
          <span className="ml-0.5 tabular-nums">{part.count}</span>
        </Typography>
      ))}
      {totalCount != null ? (
        <Typography
          variant="span2"
          component="span"
          className="inline-flex items-baseline whitespace-nowrap font-medium text-gray-800"
          role="listitem"
        >
          <span className="mx-0.5 text-gray-400" aria-hidden>
            ·
          </span>
          Total:<span className="ml-0.5 tabular-nums">{totalCount}</span>
        </Typography>
      ) : null}
    </div>
  );
}
